import axios from 'axios'
import qs from 'qs'
import { getToken } from './utils.js'
import router from '@/router/index.js'
// const Environment = process.env.NODE_ENV
const http = axios.create({
  // baseURL: Environment==='development'?'/api':null,
  timeout: 30000, // 请求超时时间
  transformRequest: [(data, header) => {
    if (getToken()) {
      data.token = getToken()
    }
    return qs.stringify(data)
  }]
})

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 可以在这里添加例如token等请求头
    // if (getToken()) {
    //   config.headers.Authorization = `Bearer ${getToken()}`
    // }
    return config
  },
  error => {
    // 请求错误处理
    return Promise.reject(error)
  }
)

// 响应拦截器
http.interceptors.response.use(
  response => {
    // token超时，回登录页
    if (response.data.result === '10021' || response.data.result === '10020') {
      router.push({
        name: 'login'
      })
    }
    // 对响应数据做处理，例如只返回data部分
    return response.data
  },
  error => {
    // 响应错误处理
    return Promise.reject(error)
  }
)

export default http
